import {
  SAVE_COLLAR_PLATES,
} from '../../actions/actionTypes'

import reducerCreator from './higherOrderEntityReducers/basicReducerCreator'

export default reducerCreator([
  SAVE_COLLAR_PLATES,
])
